import { BrowserAnalyticsClient } from '@goodneighbor/analytics/browser';

export const analytics = new BrowserAnalyticsClient({
  writeKey: process.env.NEXT_PUBLIC_RUDDERSTACK_WRITE_KEY || '',
  dataPlaneUrl: process.env.NEXT_PUBLIC_RUDDERSTACK_DATA_PLANE_URL || '',
  enabled: !!process.env.NEXT_PUBLIC_RUDDERSTACK_WRITE_KEY,
  debug: process.env.NODE_ENV === 'development'
});
